export default __webpack_public_path__ + "static/media/visualstudio.6ca64e46.png";